const PAYMENT_SUCCEEDED = 'succeeded'
const PAYMENT_FAILED = 'failed'
const PAYMENT_PROCESSING = 'processing'

export { PAYMENT_SUCCEEDED, PAYMENT_FAILED, PAYMENT_PROCESSING }
